<form [formGroup]="locationForm" (ngSubmit)="submitForm()">
  <div class="lg:flex lg:flex-row-reverse lg:gap-4 mt-16">
    <div formGroupName="address" class="lg:w-3/5">
      <div class="md:flex md:gap-4 md:mb-8 mb-0">
        <p-floatlabel class="w-full md:w-2/3 mb-8 md:mb-0">
          <input [id]="id + 'logradouro'" pInputText type="text" formControlName="street" [pTooltip]="
                  formWatched['children']['address']['children']['street']()
                    | formFieldFeedback
                " tooltipEvent="focus" tooltipPosition="bottom" required class="w-full" />
          <label [for]="id + 'logradouro'">Logradouro</label>
        </p-floatlabel>

        <p-float-label class="w-full md:w-1/3 mb-8 md:mb-0">
          <input [id]="id + 'numero'" pInputText type="text" formControlName="number" [pTooltip]="
                  formWatched['children']['address']['children']['number']()
                    | formFieldFeedback
                " tooltipEvent="focus" tooltipPosition="bottom" required class="w-full" />
          <label [for]="id + 'numero'">Número</label>
        </p-float-label>
      </div>
      <div class="md:flex md:gap-4 md:mb-8">
        <p-floatlabel class="w-full md:w-2/3 mb-8 md:mb-0">
          <input [id]="id + 'bairro'" pInputText type="text" formControlName="neighborhood" [pTooltip]="
                  formWatched['children']['address']['children']['neighborhood']()
                    | formFieldFeedback
                " tooltipEvent="focus" tooltipPosition="bottom" required class="w-full" />
          <label [for]="id + 'bairro'">Bairro</label>
        </p-floatlabel>

        <div class="w-full md:w-1/3 mb-8 md:mb-0">
          <p-float-label class="w-full">
            <p-inputmask [id]="id + 'cep'" (focusout)="onFetchAndFillFromZipCode()" type="text" mask="99999-999"
              [pTooltip]="
                    formWatched['children']['address']['children']['zipCode']()
                      | formFieldFeedback
                  " tooltipEvent="focus" tooltipPosition="bottom" slotChar="" formControlName="zipCode" required />
            <label [for]="id + 'cep'">CEP</label>
          </p-float-label>

        </div>
      </div>
      <div class="mb-8 md:mb-8">
        <p-floatlabel class="w-full">
          <input [id]="id + 'complemento'" pInputText type="text" formControlName="complement" [pTooltip]="
                  formWatched['children']['address']['children']['complement']()
                    | formFieldFeedback
                " tooltipEvent="focus" tooltipPosition="bottom" required class="w-full" />
          <label [for]="id + 'complemento'">Complemento</label>
        </p-floatlabel>

      </div>
      <div class="md:flex md:gap-4 md:mb-4">
        <p-floatlabel class="w-full md:w-3/4 mb-8 md:mb-0">
          <input [id]="id + 'cidade'" pInputText type="text" formControlName="city" [pTooltip]="
                  formWatched['children']['address']['children']['city']()
                    | formFieldFeedback
                " tooltipEvent="focus" tooltipPosition="bottom" required class="w-full" />
          <label [for]="id + 'cidade'">Cidade</label>
        </p-floatlabel>

        <p-floatlabel class="w-full md:w-1/4 mb-8 md:mb-0">
          <input [id]="id + 'estado'" pInputText type="text" formControlName="state" [pTooltip]="
            formWatched['children']['address']['children']['state']()
              | formFieldFeedback
          " tooltipEvent="focus" tooltipPosition="bottom" required class="w-full" />
          <label [for]="id + 'estado'">Estado</label>
        </p-floatlabel>
      </div>
    </div>
    <div class="lg:w-2/5">
      <div class="mb-8">
        <p-float-label>
          <p-inputmask [id]="id + 'telefone'" type="tel" mask="(99) 99999-9999" [pTooltip]="
              formWatched['children']['finderPhone']() | formFieldFeedback
            " slotChar="" formControlName="finderPhone" />
          <label [for]="id + 'telefone'">Telefone</label>
        </p-float-label>
      </div>
      <div class="mb-8">
        <p-float-label>
          <textarea [id]="id + 'detalhes'" rows="5" pTextarea formControlName="detail"
            [pTooltip]="formWatched['children']['detail']() | formFieldFeedback" resize="none" tooltipEvent="focus"
            tooltipPosition="bottom" class="w-full" required></textarea>
          <label [for]="id + 'detalhes'">Detalhes</label>
        </p-float-label>
      </div>
      <div class="mb-8">
        <p-float-label>
          <textarea [id]="id + 'medicacao'" rows="5" pTextarea formControlName="medication" resize="none"
            tooltipEvent="focus" tooltipPosition="bottom" class="w-full"></textarea>
          <label [for]="id + 'medicacao'">Medicação</label>
        </p-float-label>
      </div>
    </div>
  </div>
  <p-button styleClass="w-full mb-8 font-semibold" [loading]="isLoading()" [disabled]="isLoading() || !enabled()"
    type="submit" [label]="initialData() ? 'Atualizar' : 'Cadastrar'" />
</form>